import { Card, Grid, CardContent } from "@material-ui/core";
import { Typography } from "@mui/material";
import {useState, useEffect} from "react";
import ArrowCircleDownIcon from '@mui/icons-material/ExpandMore';
import ArrowCircleUpIcon from '@mui/icons-material/ExpandLess';

const TopologyCard = (props) => {
    const {cardName= '', cardValue} = props
    return (
            
           <Grid xs={12} sm={6} md={3} lg={2} className="card-container">
               <Card className="card-widget" style={{width: "190px", flexShrink: 0, backgroundColor:"#F9F9F9"}}>
                {cardValue ? 
                   <CardContent>
                       <Typography
                        className="topologyCard"         
                       >
                           {cardName}
                       </Typography>
                       <Typography
                           className="topologyCard1"
                       >
                           {cardValue}
                       </Typography>
                   </CardContent> : 
                   <CardContent>
                    <Typography
                            className="topologyCard"
                       >
                        {cardName}
                       </Typography>
                    <Typography
                            className="topologyCard1"
                       >
                           {"-"}
                       </Typography>
                   </CardContent>
                }
               </Card>
           </Grid>
       )
}

const TopologyCards = (props) => {
    const {topologyTopcards, openTopologyCards, setOpenTopologyCards} = props;
    return (
      <Grid className="topology">
        <Grid onClick={()=>{setOpenTopologyCards(!openTopologyCards)}} className="topologyCollapse">
            {openTopologyCards ? <ArrowCircleUpIcon className="collapse-icon"  /> : <ArrowCircleDownIcon className="collapse-icon"  />}
        </Grid>
        {openTopologyCards && <Grid
            container
            spacing={2}
            className="topologyCards"
        >
            <TopologyCard cardName={"Total Orgs"} cardValue={topologyTopcards?.data?.rows[0][0]}/>
            <TopologyCard cardName={"Total Sites"} cardValue={topologyTopcards?.data?.rows[0][1]}/>
            <TopologyCard cardName={"Online Sites"} cardValue={topologyTopcards?.data?.rows[0][2]}/>
            <TopologyCard cardName={"Offline Sites"} cardValue={topologyTopcards?.data?.rows[0][3]}/>
            <TopologyCard cardName={"Unknown Sites"} cardValue={topologyTopcards?.data?.rows[0][4]}/>
            <TopologyCard cardName={"Total Service Line"} cardValue={topologyTopcards?.data?.rows[0][5]}/>
        </Grid>}
      </Grid>
    )
}

export default TopologyCards;